import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const AddNewFinalDomain = ({ getCDISCStudyFinalDomain, studyId }) => {
  const [versions, setVersions] = useState([]);
  const [versionId, setVersionId] = useState("");

  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");

  const [domains, setDomains] = useState([]);
  const [domainId, setDomainId] = useState("");
  const [selectedDomain, setSelectedDomain] = useState(null);

  const [buttonLoader, setButtonLoader] = useState(false);

  /* -------------------- API CALLS -------------------- */

  const getVersionsForPullData = async () => {
    const res = await cdiscManagementService.getVersionsForPullData("active");
    setVersions(res?.data || []);
  };

  const getClassForPullData = async (versionId) => {
    if (!versionId) return;
    const res = await cdiscManagementService.getClassForPullData("active", versionId);
    setClasses(res?.data || []);
  };

  const getDomainsData = async (classId) => {
    if (!classId) return;
    const res = await cdiscManagementService.getDomainData("active", classId);
    setDomains(res?.data || []);
  };

  /* -------------------- EFFECTS -------------------- */

  useEffect(() => {
    getVersionsForPullData();
  }, []);

  useEffect(() => {
    getClassForPullData(versionId);
    setClassId("");
    setDomains([]);
    setDomainId("");
    setSelectedDomain(null);
  }, [versionId]);

  useEffect(() => {
    getDomainsData(classId);
    setDomainId("");
    setSelectedDomain(null);
  }, [classId]);

  useEffect(() => {
    const domainObj = domains.find(d => d.domainId === domainId);
    setSelectedDomain(domainObj || null);
  }, [domainId, domains]);

  /* -------------------- SUBMIT -------------------- */

  const addNewCDISCStudyFinalDomain = async () => {
    if (!selectedDomain) return;
    setButtonLoader(true);
    const userData = {
      targetDomainName: selectedDomain.code,
      targetDomainLabel: selectedDomain.domain,
      targetDomainClass: selectedDomain.class,
      targetDomainType: selectedDomain.type,
      key: selectedDomain.keyVariables,
      studyId: studyId,
    };

    const data = await cdiscManagementService.addNewCDISCStudyFinalDomain(userData);

    if (data?.statusCode === 200) {
      getCDISCStudyFinalDomain();
      setDomainId("");
      setVersionId("");
      setClassId("");
      setSelectedDomain(null);
    }

    setButtonLoader(false);
  };

  /* -------------------- UI -------------------- */

  return (
    <div className="p-2">
      {/* Version */}
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Version <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select value={versionId} onChange={(e) => setVersionId(e.target.value)}>
          <option value="">Select Version</option>
          {versions.map(v => (
            <option key={v.versionId} value={v.versionId}>
              {v.version}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Class */}
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Class <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select value={classId} onChange={(e) => setClassId(e.target.value)}>
          <option value="">Select Class</option>
          {classes.map(c => (
            <option key={c.classId} value={c.classId}>
              {c.class}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Domain */}
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">
          Domain <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select value={domainId} onChange={(e) => setDomainId(e.target.value)}>
          <option value="">Select Domain</option>
          {domains.map(d => (
            <option key={d.domainId} value={d.domainId}>
              {d.domain} ({d.code})
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {/* Auto-filled fields */}
      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">Target Domain Name</Form.Label>
        <Form.Control placeholder="Enter Domain Name" disabled value={selectedDomain?.code || ""} />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">Target Domain Label</Form.Label>
        <Form.Control placeholder="Enter Domain Label" disabled value={selectedDomain?.domain || ""} />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">Target Domain Class</Form.Label>
        <Form.Control placeholder="Enter Domain Class" disabled value={selectedDomain?.class || ""} />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">Target Domain Type</Form.Label>
        <Form.Control placeholder="Enter Domain Type" disabled value={selectedDomain?.type || ""} />
      </Form.Group>

      <Form.Group className="mb-2">
        <Form.Label className="fw-bold mb-1">Key</Form.Label>
        <Form.Control
          placeholder="Enter Key"
          disabled
          value={selectedDomain?.keyVariables?.join(", ") || ""}
        />
      </Form.Group>

      {/* Submit */}
      <Form.Group className="text-end">
        <button className="updateProfile" onClick={addNewCDISCStudyFinalDomain}>
          {buttonLoader ? (
            <>
              <Spinner size="sm" /> Adding...
            </>
          ) : (
            "Add Domain"
          )}
        </button>
      </Form.Group>
    </div>
  );
};

export default AddNewFinalDomain;
